module.exports = __webpack_public_path__ + "img/like.40b641ca.svg";